module.exports = __webpack_public_path__ + "img/bi-1.e5d4483b.svg";